module.exports = __webpack_public_path__ + "img/img_tab_mo_on.e9d6b03f.svg";